import bottomCurve from "planets/union/bottom-curve"
import trail from "planets/union/trail"
import {
  PlanetHorizon,
  ShortPlanetHorizon,
  PlanetHorizonContainer,
  ShortPlanetHorizonContainer,
  PlanetHorizonTitle
} from "planets/union/horizon"
import editProfileBackground from "planets/union/union-edit-profile-stones.svg"

export default {
  mainColor: "#2c626e",
  secondaryColor: "#ffb3b3",
  bottomCurve: bottomCurve,
  trail: trail,
  knowledgeAreaSlide: { prev: "#ccc", next: "#ccc" },
  dailyMission: {
    questionSlider: { prev: "#262547", next: "#262547", arrowColor: "#fff" }
  },
  btnPrimary: { backgroundColor: "#ff9229", textColor: "#fff", shadowColor: "#ce6d10" },
  btnLink: { backgroundColor: "#2c626e", activeTextColor: "#ff9229" },
  gamificationBar: {
    white: { textColor: "#2c626e" },
    colored: { textColor: "#fff" }
  },
  header: { colored: { backgroundColor: "#8e3fac" } },
  horizon: {
    PlanetHorizon,
    ShortPlanetHorizon,
    PlanetHorizonContainer,
    ShortPlanetHorizonContainer,
    PlanetHorizonTitle
  },
  editProfileBackground: editProfileBackground,
  games: {
    title: "#fd5d0a",
    border: "#fd5d0a",
    detailsHeader: "#2c626e"
  }
}
